// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0c3325d3","884":"8a228cdb"}[chunkId] + ".chunk.js";
};